(function() {
    'use strict';
    angular
        .module('gwApp')
        .factory('Permission', Permission);

    Permission.$inject = ['$resource'];

    function Permission ($resource) {
        var resourceUrl =  'api/permissions/:id';

        return $resource(resourceUrl, {}, {
            'getAllByScope':{
                method: 'GET', isArray: true,
                params: {
                    id: 'getAllByScope'
                },
            },
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
